import ColFreezeMenu from "./controls/ColFreezeMenu";
import FullScreenButton from "./controls/FullcreenButton";
import { Fragment, useEffect, useState } from "react";
import React from "react";
import ColDisplayMenu from "./controls/ColDisplayMenu";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { API_URL_TENDERS_EXPORT } from "../../../configuration/Configuration";
import { extractFilenameFromContentDisposition } from "../../../configuration/Utils";
import {
  getColumnLayoutScope,
  hasSavedColumnLayout,
} from "./columnLayoutPersistence";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export const tableControlStyle = {
  border: "none",
  color: "black",
  "&:hover": {
    backgroundColor: "transparent",
    color: "black",
    textDecoration: "underline",
    transition: "none", // Disable transition animations
  },
  "&:active": {
    color: "#1876D2",
  },
};

const TableControls = ({
  table,
  fullScreenHandle,
  ref,
  tenders,
  user,
  showImport,
  showExport,
  showExportDropdown = true,
  layoutScope,
}) => {
  const navigate = useNavigate();
  const resolvedLayoutScope = layoutScope ?? getColumnLayoutScope(tenders);
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const exportMenuOpen = Boolean(exportAnchorEl);

  // Move column auto-sizing to useEffect to avoid setState during render
  useEffect(() => {
    if (
      table.current &&
      table.current.columnApi &&
      !hasSavedColumnLayout(resolvedLayoutScope)
    ) {
      let columnApi = table.current.columnApi;
      columnApi.autoSizeAllColumns();
    }
  }, [resolvedLayoutScope, table]);

  const downloadFile = async (tenders) => {
    // Get the current column order from the AG Grid table
    let columnOrder = [];
    if (table.current && table.current.columnApi) {
      const allColumns = table.current.columnApi.getAllDisplayedColumns();
      columnOrder = allColumns.map(col => col.getColId());
    }

    const url_api_file = `${API_URL_TENDERS_EXPORT}${user}/${tenders}/lane/`;

    try {
      const response = await axios.post(url_api_file, 
        { columnOrder },
        {
          responseType: "blob",
        }
      );
      const contentDisposition = response.headers["content-disposition"];
      
      // Better filename extraction that handles quoted filenames
      const filename = extractFilenameFromContentDisposition(contentDisposition);
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const downloadSimpleFile = async (tenders) => {
    const url_api_file = `${API_URL_TENDERS_EXPORT}${user}/${tenders}/simple/`;

    try {
      const response = await axios.post(url_api_file, {}, { responseType: "blob" });
      const contentDisposition = response.headers["content-disposition"];
      const filename = extractFilenameFromContentDisposition(contentDisposition);

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error("Error downloading simple export:", error);
    }
  };

  return (
    <Fragment>
      <div style={{ textAlign: "right" }}>
        {showExport && (
          <>
            {showExportDropdown ? (
              <>
                <Button
                  startIcon={<FileDownloadOutlinedIcon />}
                  sx={tableControlStyle}
                  onClick={(e) => setExportAnchorEl(e.currentTarget)}
                >
                  EXPORT
                </Button>
                <Menu
                  anchorEl={exportAnchorEl}
                  open={exportMenuOpen}
                  onClose={() => setExportAnchorEl(null)}
                >
                  <MenuItem
                    onClick={() => {
                      setExportAnchorEl(null);
                      downloadFile(tenders);
                    }}
                  >
                    Standard
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setExportAnchorEl(null);
                      downloadSimpleFile(tenders);
                    }}
                  >
                    Simple (Price + Capacity)
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <Button
                startIcon={<FileDownloadOutlinedIcon />}
                sx={tableControlStyle}
                onClick={() => downloadFile(tenders)}
              >
                EXPORT
              </Button>
            )}
          </>
        )}
        {showImport && (
          <Button
            startIcon={<FileUploadOutlinedIcon />}
            sx={tableControlStyle}
            onClick={() => {
              navigate(`/import/?id=${tenders}`);
            }}
          >
            IMPORT
          </Button>
        )}

        <FullScreenButton fullScreenHandle={fullScreenHandle} />
        <ColFreezeMenu table={table} ref={ref} layoutScope={resolvedLayoutScope} />
        <ColDisplayMenu table={table} layoutScope={resolvedLayoutScope} />
      </div>
    </Fragment>
  );
};
export default TableControls;
